import React from 'react';
import MemberDetail from './index';

const MemberPulse: React.FC = () => {
  return <MemberDetail section="pulse" />;
};

MemberPulse.displayName = 'MemberPulse';
export default MemberPulse;
